import {remote} from '../constants/environment';
import {INotificationListResponse} from '../interfaces/services/notification-list-response.interface';
import {customFetch as fetch, remoteCall} from '../utils/services';
import {defaultHeaders} from './headers';

export const deleteAccount = async (
  token: string,
): Promise<INotificationListResponse> => {
  const remoteURI = remote.getRemoveAccountUri();
  return (await remoteCall(
    async () => {
      return await fetch(remoteURI, {
        method: 'DELETE',
        headers: {
          ...defaultHeaders,
          'token-session': token,
        },
      });
    },
    async (response: Response) => {
      if (response.status === 200) {
        const data = await response.json();

        if (data.success && data.payload) {
          const success = true;
          return {
            success,
            payload: null,
          };
        } else {
          return {
            success: false,
            payload: null,
          };
        }
      }
    },
    remoteURI,
  )) as INotificationListResponse;
};
